import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import * as API from '../utils/api'
import axios from '../utils/axios'

const initalState = {
    status: 'idle',
    entity: null,
    error: null,
}

export const fetchPost = createAsyncThunk(
    'post/fetchEmployee', 
    async (data) => {
        const {postCode} = data
        const url = API.EMPLOYEE_API.replace('{0}', postCode)
        return await axios.get(url)
                            .then(response => response.data)
    }
)

const postSlice = createSlice({
    name: 'post',
    initialState: initalState,
    reducers:{

    },
    extraReducers:{
        [fetchPost.pending]: (state, action) => {
            state.status = 'loading'
        },
        [fetchPost.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            state.entity = action.payload
        },
        [fetchPost.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        },
    }
})

export default postSlice.reducer
